import React from 'react';
import { makeStyles, Grid, Typography } from "@material-ui/core";
import { LIGHT_GRAY_COLOR, SECONDARY_COLOR } from '../../theme';
import { XCircle } from 'react-feather';

const MensagemListagemVazia = ({ mensagem, iconeCustom, children, className }) => {
    const classes = useStyles();
    const linhasMensagem = mensagem && mensagem.split('\n');

    return (
        <Grid item xs={12} className={`${classes.root} ${className || ""}`}>
            <div className={classes.box}>
                {iconeCustom
                    ? iconeCustom({ color: SECONDARY_COLOR, className: classes.icone })
                    : <XCircle color={SECONDARY_COLOR} className={classes.icone} />}

                {mensagem
                    ? linhasMensagem.map((linha, index) =>
                        <Typography className={classes.mensagem} key={index}>
                            {linha}
                        </Typography>)
                    :
                    <Typography className={classes.mensagem}>
                        {children}
                    </Typography>

                }
            </div>
        </Grid>
    )
}

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: "40px",
        marginBottom: "40px"
    },
    box: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        borderWidth: 1,
        borderStyle: "dashed",
        borderColor: LIGHT_GRAY_COLOR,
        padding: "20px"
    },
    icone: {
        margin: "20px 0px"
    },
    mensagem: {
        textAlign: "center",
    }
}))

export default MensagemListagemVazia;